import { FC } from 'react';

import Collapse from '@components/Collapse/Collapse';
import {
  ListingFilterItemInterface,
  ListingFilterItemKey,
} from '@components/ui/filters/MultiSelectionFilter/types';

import { ClassChip, ClassChipList, ClassFilterTitle } from './ClassFilterStyle';

interface ClassFilterProps {
  title: string;
  data: ListingFilterItemInterface[];
  selectedItems: ListingFilterItemKey[];
  handleSelectedItems: (items: ListingFilterItemKey[]) => void;
}

const ClassFilter: FC<ClassFilterProps> = ({
  title,
  data,
  selectedItems,
  handleSelectedItems,
}) => {
  if (!data.length) return null;

  const toggle = (key: ListingFilterItemKey) => {
    const isSelected = selectedItems.some(
      (item) => String(item) === String(key)
    );

    handleSelectedItems(
      isSelected
        ? selectedItems.filter((item) => String(item) !== String(key))
        : [...selectedItems, key]
    );
  };

  return (
    <Collapse
      defaultActiveKey='hotel-class-filter'
      panelProps={{
        header: <ClassFilterTitle>{title}</ClassFilterTitle>,
        key: 'hotel-class-filter',
      }}
    >
      <ClassChipList>
        {data.map((item) => {
          const selected = selectedItems.some(
            (selectedItem) => String(selectedItem) === String(item.key)
          );

          return (
            <ClassChip
              key={item.key}
              type='button'
              $selected={selected}
              aria-pressed={selected}
              onClick={() => toggle(item.key)}
            >
              <img
                src='/static/icons/icon-star.svg'
                alt=''
                width={12}
                height={11}
              />
              {String(item.value ?? item.key).split(' ')[0]}
            </ClassChip>
          );
        })}
      </ClassChipList>
    </Collapse>
  );
};

export default ClassFilter;
